import { ResponsiveScatterPlot } from "@nivo/scatterplot"

const ScatterPlot = ({ data }) => {

const chartDataPre = Object.values(data.data.units).map((u) => {
    var {ChargeEvent, MaxCharge, RechargeDuration, Range,Armours, HP, AccuracyPercent, Attack,Cost, ReloadTime, FrameDelay, AttackDelaySeconds } = u;


    var maxArmor = Math.max( ...Armours.map(a => a.Amount))  || 1

    return {...u,

    Range,

        name: u.internal_name,
        hp: HP,
        attack: Attack,
        thirtysecondsattack: ((Attack  + (ChargeEvent * MaxCharge / RechargeDuration || 1)) * AccuracyPercent/100 / (ReloadTime + AttackDelaySeconds)) || 0,
        combinedCost: (Cost.Gold || 0)  + (Cost.Wood || 0) + (Cost.Food || 0),
        Cost,
        hpIndex: Math.sqrt(maxArmor+1) * HP

    }

});

const chartData = [  {
                       "id": "ranged",
                       "data": []
                       },
                       {   "id": "melee",
                        "data": []
                        }
                    ]


chartDataPre.filter(f => f.thirtysecondsattack < 11 && f.hpIndex < 1500).forEach( d => {

const toPush = {
                           id: d.ID,
                           x: d.thirtysecondsattack,
                           name: d.name,
                           y: d.hpIndex,
                           z: d.combinedCost
                       }


if ( d.Range > 1) {
chartData[0].data.push(toPush)
} else {
chartData[1].data.push(toPush)
}
 });

console.debug("chartData", chartData)

return (
    <ResponsiveScatterPlot
         tooltip={({ node }) => (
               <div
                   style={{
                       color: node.color,
                      background: '#333',
                       padding: '12px 16px',
                    }}
                >
                    <strong>
                        {node.data.name}
                    </strong>
                    <br />
                    <img width="45.15" height="45.15" id="unit_7_img" src={"https://aoe2techtree.net/img/Units/" + node.data.id + ".png"} />
                </div>
            )}
        nodeSize={{ key: 'data.z', values: [0, 500], sizes: [5, 52] }}
        data={chartData}
        margin={{ top: 50, right: 110, bottom: 60, left: 80 }}
        xScale={{ type: 'linear', min: 0, max: 'auto' }}
                xFormat=">-.2f"
                yScale={{ type: 'linear', min: 0, max: 'auto' }}
                yFormat=">-.2f"
                blendMode="multiply"
                axisTop={null}
                axisRight={null}
                axisBottom={{
                    orient: 'bottom',
                    tickSize: 5,
                    tickPadding: 5,
                    tickRotation: 0,
                    legend: 'attack in 1 second',
                    legendPosition: 'middle',
                    legendOffset: 46
                }}
                axisLeft={{
                    orient: 'left',
                    tickSize: 5,
                    tickPadding: 5,
                    tickRotation: 0,
                    legend: 'health indication',
                    legendPosition: 'middle',
                    legendOffset: -60
                }}
                legends={[
                    {
                        anchor: 'bottom-right',
                        direction: 'column',
                        justify: false,
                        translateX: 130,
                        translateY: 0,
                        itemWidth: 100,
                        itemHeight: 12,
                        itemsSpacing: 5,
                        itemDirection: 'left-to-right',
                        symbolSize: 12,
                        symbolShape: 'circle',
                        effects: [
                            {
                                on: 'hover',
                                style: {
                                    itemOpacity: 1
                                }
                            }
                        ]
                    }
                ]}
    />
)}

export default ScatterPlot;